export const environment = {
  production: true,
  apiBaseUrl: '/api',
  ssrIgnoresSsl: false,
  clarity: {
    enabled: true,
  },
};
